/* Publish by EComposer at 2026-10-07 19:11:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2qzgebiz9hx"]=  window.__ectimmers["ecom-2qzgebiz9hx"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2qzgebiz9hx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2qzgebiz9hx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqvuly5n0ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqvuly5n0ug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki29d5e88up').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki29d5e88up', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urx4qfmem4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urx4qfmem4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm8i66z8c2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm8i66z8c2b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nyuibeayrm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nyuibeayrm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-267xd4r3dn1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-267xd4r3dn1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xihj5ds5wak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xihj5ds5wak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfuutd172l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfuutd172l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ijxavrbv6sd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ijxavrbv6sd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hj7p3iyix3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hj7p3iyix3w', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kcfbehv7iu"]=  window.__ectimmers["ecom-kcfbehv7iu"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-kcfbehv7iu"]["283cx3uex"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-kcfbehv7iu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcfbehv7iu', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f6efhzkwhi6"]=  window.__ectimmers["ecom-f6efhzkwhi6"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-f6efhzkwhi6"]["pkggfnjf3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-f6efhzkwhi6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f6efhzkwhi6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32q24w6fes4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32q24w6fes4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgv8fxjiks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgv8fxjiks', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e85tivy4oy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e85tivy4oy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2x3vuadsgnx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2x3vuadsgnx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5upcvbxw72f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5upcvbxw72f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y32pimpmxcd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y32pimpmxcd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ytuylu836fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ytuylu836fk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}